module.exports = __webpack_public_path__ + "img/category-detail-icon0.3abe90f7.svg";